import axios from 'axios';

import { productList } from 'common/helpers/product';

/* ==================================== Local Types ==================================== */
type IAddGiftCardPayload = { key: string; amount: string; startDate: number; endDate: number; campaign: string };

/* ==================================== Exported Functions ==================================== */
// ==================================== CREATE
export const addGiftCard = async (endpoint: { url: string; header: any }, data: IAddGiftCardPayload) => {
  return axios
    .post(`${endpoint.url}/v1/cards`, data, {
      headers: {
        'x-top-appname': endpoint.header
      }
    })
    .catch((err) => {
      throw Error(err.response.data.errorMessage);
    });
};

// ==================================== GET
export const getGiftCardsByType = async (endpoint: { url: string; header: any }, type: keyof typeof productList) => {
  return axios.get(`${endpoint.url}/v1/cards?key=${type}&list=all`, {
    headers: {
      'x-top-appname': endpoint.header
    }
  });
};

// ==================================== UPDATE
export const updateGiftCard = async (endpoint: { url: string; header: any }, id: string, data: IAddGiftCardPayload) => {
  return axios
    .put(`${endpoint.url}/v1/cards?id=${id}`, data, {
      headers: {
        'x-top-appname': endpoint.header
      }
    })
    .catch((err) => {
      throw Error(err.response.data.errorMessage);
    });
};

// ==================================== DELETE
export const deleteGiftCard = async (endpoint: { url: string; header: any }, id: string, key: string) => {
  return axios
    .delete(`${endpoint.url}/v1/cards?id=${id}&key=${key}`, {
      headers: {
        'x-top-appname': endpoint.header
      }
    })
    .catch((err) => {
      throw Error(err.response.data.errorMessage);
    });
};
